module.exports = __webpack_public_path__ + "img/parliament.9bd50200.webp";